import type { PropsWithChildren } from "react";
import React, { useCallback, useState } from "react";
import type { ApiError } from "@entrilia/shared/api/types";
import ImpersonationBlockedDialog from "../components/impersonation/ImpersonationBlockedDialog";

interface ContextValue {
  isBlockedUnderImpersonation: (error: ApiError) => boolean;
  showImpersonationBlockedDialog: () => void;
}

const ImpersonationBlockContext = React.createContext<ContextValue | undefined>(undefined);

const isBlockedUnderImpersonation = (error: ApiError): boolean => error.type === "ActionUnavailableDuringImpersonation";

export const ImpersonationBlockContextProvider = ({ children }: PropsWithChildren) => {
  const [open, setOpen] = useState(false);

  const showImpersonationBlockedDialog = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <ImpersonationBlockContext value={{ isBlockedUnderImpersonation, showImpersonationBlockedDialog }}>
      {children}
      <ImpersonationBlockedDialog open={open} onClose={handleClose} />
    </ImpersonationBlockContext>
  );
};

export default ImpersonationBlockContext;
